<template>
  <div>
    <v-menu
      v-model="menu"
      bottom
      right
      :close-on-content-click="false"
      transition="scale-transition"
      origin="top left"
    >
      <template v-slot:activator="{ on }">
        <slot name="chip" :on="on">
          <v-chip
            elevation="0"
            label
            outlined
            :close="close"
            close-icon="mdi-close"
            height="auto"
            v-on="on"
            @click:close="$emit('remove')"
          >
            <div class="font-weight-medium">
              {{ user.firstName }} {{ user.lastName }}
            </div>
            <div
              v-if="!user.firstName && !user.lastName"
              class="font-weight-medium"
            >
              ({{ user.username }})
            </div>
          </v-chip>
        </slot>
      </template>
      <v-card min-width="250" class="pa-2">
        <v-row align="center" dense>
          <v-col cols="auto">
            <tcn-au-user-avatar v-model="user" size="40" left />
          </v-col>
          <v-col cols="auto" class="user-details">
            <span class="font-weight-bold"
              >{{ user.firstName }} {{ user.lastName }}</span
            >
            <span
              v-if="!user.firstName && !user.lastName"
              class="font-weight-bold"
            >
              ({{ user.username }})
            </span>
            <br />
            <span>{{ user.email }}</span>
          </v-col>
        </v-row>
        <v-divider v-if="contactInfo" class="my-2 mx-0"></v-divider>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import TcnAuUserAvatar from "../TecnaAureaUserAvatar";

export default defineComponent({
  name: "TcnAuUserChip",
  components: { TcnAuUserAvatar },
  props: {
    value: Object,
    close: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    user: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    contactInfo() {
      return false;
    },
  },
  methods: {},
});
</script>

<style lang="scss" scoped>
.user-avatar {
  margin: 3px;
}
.user-details {
  line-height: normal;
}
</style>
